export default __webpack_public_path__ + "static/assets/b2e37e698b1672b970671908f2f94004.jpg";